import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';

interface NavigationItem {
  label: string;
  route: string;
  icon: string;
}

@Component({
  selector: 'app-shell-page',
  templateUrl: './app-shell.page.html',
  styleUrls: ['./app-shell.page.scss'],
})
export class AppShellPage {
  readonly navigation: NavigationItem[] = [
    { label: 'Dashboard', route: '/app/dashboard', icon: 'grid-outline' },
    { label: 'Setup Wizard', route: '/app/setup', icon: 'sparkles-outline' },
    { label: 'Contacts', route: '/app/contacts', icon: 'people-outline' },
    { label: 'Templates', route: '/app/templates', icon: 'albums-outline' },
    { label: 'Campaigns', route: '/app/campaigns', icon: 'rocket-outline' },
  ];

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router
  ) {}

  logout(): void {
    this.auth.logout();
    void this.router.navigateByUrl('/auth/login');
  }
}
